import { useEffect, useRef } from 'react';

// IntersectionObserver accounts for every scroll ancestor, including horizontal mobile panels.
export default function InfiniteScrollSentinel({ hasMore, loading, error, onLoadMore, onRetry, count = 0 }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!hasMore || loading || error || !ref.current) return;
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) onLoadMore();
    }, { rootMargin: '120px' });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [hasMore, loading, error, onLoadMore, count]);
  if (!hasMore && !loading && !error) return null;
  return <div ref={ref} className="infinite-scroll-sentinel" style={{ flexShrink: 0, gridColumn: '1 / -1', minWidth: 44, minHeight: 44, padding: 12, textAlign: 'center' }}>
    {error ? <button type="button" onClick={onRetry}>Couldn’t load more. Retry</button> :
      loading ? <span role="status">Loading…</span> :
        <button type="button" onClick={onLoadMore}>Load more</button>}
  </div>;
}
